import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Menu, QrCode, MonitorSmartphone, User } from "lucide-react";
import DashboardSidebar from "./DashboardSidebar";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "@/hooks/useAuth";
import { useState } from "react";

type DashboardHeaderProps = {
  isMobile: boolean;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  onNewDevice: () => void;
};

const DashboardHeader = ({
  isMobile,
  isDrawerOpen,
  setIsDrawerOpen,
  onNewDevice,
}: DashboardHeaderProps) => {
  const { user } = useAuth();

  return (
    <>
      <header className="bg-card shadow-sm border-b h-16 px-4 flex items-center justify-between sticky top-0 z-20">
        {isMobile && (
          <button
            type="button"
            className="mr-2 flex items-center justify-center h-10 w-10 z-50 md:hidden"
            onClick={() => setIsDrawerOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </button>
        )}
        <div className={isMobile ? "flex-1 flex justify-center items-center" : "flex items-center gap-4"}>
          <img
            src="https://link.letswatch.com.br/storage/27001/logo_watch_Smart_Media.png"
            alt="Watch Logo"
            className="h-10 sm:h-14 object-contain transition-all"
          />
        </div>

        <div className="flex items-center gap-4">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                {isMobile ? (
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={onNewDevice}
                    className="bg-primary/10 hover:bg-primary/20 transition-colors"
                  >
                    <MonitorSmartphone className="h-5 w-5 text-primary" />
                  </Button>
                ) : (
                  <Button
                    variant="outline"
                    onClick={onNewDevice}
                    className="bg-primary/10 hover:bg-primary/20 transition-colors gap-2"
                  >
                    <MonitorSmartphone className="h-5 w-5 text-primary" />
                    <span className="text-primary font-medium">Ativar Aparelho</span>
                  </Button>
                )}
              </TooltipTrigger>
              <TooltipContent>
                <p>Ativar novo dispositivo</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </header>


    </>
  );
};

export default DashboardHeader;
